import { cn } from '@/utils/styles';
import { Button } from '@design-system/Button';
import { ListIcon } from '@/components/icons/ListIcon';
import { GridIcon } from '@/components/icons/GridIcon';
import type { DisplayMode } from './MyFoodsPage.model';

interface MyFoodsPageDisplayModeButtonProps
  extends React.ComponentPropsWithoutRef<typeof Button> {
  displayMode?: DisplayMode;
}

export const MyFoodsPageDisplayModeButton = ({
  className,
  displayMode,
  ...rest
}: MyFoodsPageDisplayModeButtonProps) => (
  <Button
    size="icon"
    variant="ghost"
    className={cn('ml-auto typography-body text-primary p-1', className)}
    {...rest}
  >
    {displayMode === 'list' ? (
      <GridIcon width={24} height={24} className="!size-6" />
    ) : (
      <ListIcon width={20} height={20} className="!size-5" />
    )}
  </Button>
);
